module.exports = __webpack_public_path__ + "static/img/07056C_1_2_C_20210228_LC.601d09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07056C_1_2_C_20210228_LC.png
// module id = S/jl
// module chunks = 0